import { List, Map } from "immutable";
import { createSelector } from "reselect";

import {
  composeSelector,
  Selector
} from "seneca-common/utils/selectors/compose-selectors";

import Course, {
  Authors,
  CourseId,
  References,
  SectionId,
  Tags
} from "../models/state/courses/course/Course";
import { Courses } from "../models/state/courses/Courses";
import * as coursesSelectors from "./state/courses";

export default function makeSelectors(getCourses: (arg0: any) => Courses) {
  const composeCoursesSelector = <R>(
    selector: (arg0: Courses, ...args: any) => R
  ): Selector<any, R> => composeSelector<any, Courses, R>(getCourses, selector);

  return {
    // @ts-ignore
    getCourse: composeCoursesSelector<Course>(coursesSelectors.getCourse),
    getAllCourseIds: createSelector<any, void, List<CourseId>, Courses>(
      // @ts-ignore
      getCourses,
      coursesSelectors.getAllCourseIds
    ),
    getAllCourseIdsWithoutPremium: createSelector<
      any,
      void,
      List<CourseId>,
      Courses
    >(
      // @ts-ignore
      getCourses,
      coursesSelectors.getAllCourseIdsWithoutPremium
    ),
    getCourseName: composeCoursesSelector<string>(
      coursesSelectors.getCourseName
    ),
    getCourseTextToSpeechEnabled: composeCoursesSelector<boolean>(
      coursesSelectors.getCourseTextToSpeechEnabled
    ),
    getCourseVocabularyEnabled: composeCoursesSelector<boolean>(
      coursesSelectors.getCourseVocabularyEnabled
    ),
    getCourseDescription: composeCoursesSelector<string>(
      coursesSelectors.getCourseDescription
    ),
    getCourseNames: composeCoursesSelector<Map<string, string>>(
      // @ts-ignore
      coursesSelectors.getCourseNames
    ),
    getCourseAuthors: composeCoursesSelector<Authors>(
      coursesSelectors.getCourseAuthors
    ),
    getCourseReferences: composeCoursesSelector<References>(
      coursesSelectors.getCourseReferences
    ),
    getCourseHeaderImageURL: composeCoursesSelector<string>(
      coursesSelectors.getCourseHeaderImageURL
    ),
    getCourseSectionIds: composeCoursesSelector<List<SectionId>>(
      coursesSelectors.getCourseSectionIds
    ),
    getCourseSubscriptionTier: composeCoursesSelector(
      coursesSelectors.getCourseSubscriptionTier
    ),
    getCourseAvailable: composeCoursesSelector<boolean>(
      coursesSelectors.getCourseAvailable
    ),
    courseIsPremium: composeCoursesSelector<boolean>(
      coursesSelectors.courseIsPremium
    ),
    courseIsFree: composeCoursesSelector<boolean>(
      coursesSelectors.courseIsFree
    ),
    getCourseStartingSectionId: composeCoursesSelector<
      SectionId | null | undefined
    >(coursesSelectors.getCourseStartingSectionId),
    getCourseTagIds: composeCoursesSelector<Tags>(
      coursesSelectors.getCourseTagIds
    ),
    getRelatedCourseIds: composeCoursesSelector<List<CourseId>>(
      coursesSelectors.getRelatedCourseIds
    ),
    getRelatedPremiumCourseIdsForCourses: composeCoursesSelector<
      List<CourseId>
    >(coursesSelectors.getRelatedPremiumCourseIdsForCourses),
    courseExists: composeCoursesSelector<boolean>(
      coursesSelectors.courseExists
    ),
    getCourseRegion: composeCoursesSelector<string>(
      // @ts-expect-error could be undefined
      coursesSelectors.getCourseRegion
    ),
    getCourseExamQuestionsCount: composeCoursesSelector(
      coursesSelectors.getCourseExamQuestionsCount
    ),
    doesCourseHaveExamQuestions: composeCoursesSelector(
      coursesSelectors.doesCourseHaveExamQuestions
    ),
    doesCourseHaveVocabulary: composeCoursesSelector(
      coursesSelectors.doesCourseHaveVocabulary
    )
  };
}
